<template>

  <div>
    <div class="mt-4 d-flex align-items-start justify-content-between">
      <back-arrow :title="$t('annonces.on.top')"/>
    </div>

    <b-container class="mt-4">
      <div class="row row-cards-annonces">
        <template v-if="annonces && annonces.length > 0">
          <transition-group v-for="annonce in annonces" :key="annonce.serverId+'annonceCard'" appear
                            class="col-container-card-annonce col-12 col-sm-12 col-md-6 col-lg-4"
                            name="listCustomTransition"
                            tag="div">
            <annonce-card-image-left :key="annonce.serverId" :annonce="annonce" class="cursor-pointer"/>
          </transition-group>
        </template>

        <!-- aucune annonce -->
        <transition-group v-else appear class="col-12 empty-state-container" name="listCustomTransition" tag="div">
          <div key="searchEmptyState-img" class="text-center mb-4">
            <img :src="require(`@/assets/images/b122/img-confused.png`)" alt="no result" class="empty-state-img">
          </div>
          <div key="searchEmptyState-txt" class=" text-center no-result-text">
            <div class="no-result-title mb-2">{{ $t('annonce.search.emptyTitle') }}</div>
            <div class="no-result-subtitle my-2">{{ $t('annonce.search.emptyText') }}</div>
          </div>
        </transition-group>

      </div>
    </b-container>

  </div>

</template>

<script>

import api from '../../services/api'
import {eventBus} from "../../main"
import AnnonceCardImageLeft from "../../components/annonce/AnnonceCardImageLeft"
import PlaceholderCardAnnonce from "./PlaceholderCardAnnonce"
import FiltersModal from "./FiltersModal"
import AnnoncesMap from "./AnnoncesMap"
import CreateSavedSearchModal from "./CreateSavedSearchModal"
import DeleteSavedSearchModal from "./DeleteSavedSearchModal"
import AlertInfoModal from "./AlertInfoModal"
import BackArrow from "../../components/b122/BackArrow.vue";

export default {
  name: 'Search',

  components: {
    BackArrow,
    AnnonceCardImageLeft,
    PlaceholderCardAnnonce,
  },

  data() {
    return {

      totalRows: 0,
      annonces: [],

    }
  },


  async mounted() {
    await this.fetchData()
  },

  methods: {

    async fetchData() {
      await this.fetchAnnoncesOnTop()
    },

    fetchAnnoncesOnTop() {
      api
        .get(`/annonce/getAnnoncesOnTopForGP`)
        .then((response) => {
          this.annonces = response.data
        })
    },
  },
}

</script>

<style scoped>

.row-cards-annonces {
  margin-right: 0.5rem;
  margin-top: 0.5rem;
  margin-left: -1rem;
}

.col-container-card-annonce {
  padding-left: 1rem;
  padding-bottom: 1rem;
  padding-right: 0px;
}

.row-cards-annonces .last-annonce-card {
  height: 100%;
}


</style>



// WEBPACK FOOTER //
// src/views/search/TopAnnonces.vue